import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import LensIcon from '@material-ui/icons/Lens';
import { useTooltipStyles } from '../../utils/styles.esm.js';

const BarChartTooltipItem = (props) => {
  const { item } = props;
  const classes = useTooltipStyles();
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      minHeight: 25
    },
    /* @__PURE__ */ React.createElement(Box, { display: "flex", alignContent: "center", marginRight: ".5em" }, /* @__PURE__ */ React.createElement(Box, { display: "flex", alignItems: "center", marginRight: ".5em" }, /* @__PURE__ */ React.createElement(LensIcon, { className: classes.lensIcon, style: { fill: item.fill } })), /* @__PURE__ */ React.createElement(Typography, null, item.label)),
    /* @__PURE__ */ React.createElement(Typography, { display: "block" }, item.value)
  );
};

export { BarChartTooltipItem };
//# sourceMappingURL=BarChartTooltipItem.esm.js.map
